import { FC, useMemo } from 'react';
import VerifiedBadge from 'assets/image/badges/en/verified.svg';
import VerifiedBadgeHE from 'assets/image/badges/he/verified.svg';
import styles from './OpportunityBadges.module.scss';

type OpportunityBadgesProps = {
	language?: string;
};

const isHebrewLanguage = (language?: string): boolean => Boolean(language?.toLowerCase().startsWith('he'));

const OpportunityBadges: FC<OpportunityBadgesProps> = ({ language }: OpportunityBadgesProps) => {
	const verifiedBadgeSvg = useMemo(() => (isHebrewLanguage(language) ? VerifiedBadgeHE : VerifiedBadge), [language]);

	return (
		<div className={styles.badges}>
			<img className={styles.badge_verified} src={verifiedBadgeSvg} alt="badge" />
		</div>
	);
};

export default OpportunityBadges;
